import axios from 'axios';
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';
import { localStorageService } from './localStorage.service.js';

export const getAllTesting = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.TESTING.ALL_TESTING}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllGrading = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.TESTING.ALL_GROUPS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getOneGrading = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.TESTING.ALL_GROUPS}/${data.groupId}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllTestLibrary = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.TESTING.ALL_LIBRARY}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getTestingReport = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.TESTING.TESTING_REPORTS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getArchiveReports = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.TESTING.GET_ARCHIVE_REPORTS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addNewTest = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.TESTING.ALL_TESTING}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const statusChanges = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.TESTING.STATUS_CHANGE}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addNewTestGroup = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.TESTING.ALL_GROUPS}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const uploadFile = async (data) => {
  const loginFormData = new FormData();
  loginFormData.append('module', data.module);
  loginFormData.append('xls', data.xls);
  try {
    return await apiClient.post(`${apiEndpoint}${API.TESTING.UPLOAD_FILE}`, loginFormData);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateTesting = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.TESTING.ALL_TESTING}/${data.id}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateTestingGroup = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.TESTING.ALL_GROUPS}/${data.id}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteTestingStatus = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.TESTING.STATUS_CHANGE}`, { data: { testCaseId: data.testCaseIds } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const deleteTesting = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.TESTING.ALL_TESTING}/${data.deleteId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteTestingGroup = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.TESTING.ALL_GROUPS}`, {
      data: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const multiDeletePom = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.TESTING.ALL_TESTING}/${data.deleteId}`, {
      data: {
        ids: [...data.multipleDeleteId],
        testingLibId: data.testingLibId,
        multipleDelete: data.multipleDelete,
      },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteTestingReport = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.TESTING.DELETE_TESTING_REPORT}/${data?.id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const exportExcelService = async (data) => {
  try {
    const userInfo = localStorageService.get('loggedInUserInfo');
    if (userInfo) {
      const config = {
        headers: { Authorization: `Bearer ${userInfo.token}` },
        responseType: 'arraybuffer',
        withCredentials: true,
      };
      return new Promise((resolve, reject) => {
        axios
          .post(`${apiEndpoint}${API.TESTING.DOWNLOAD_TEST_LIBRARY}`, data, config)
          .then((response) => {
            const blob = new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            resolve(blob);
          })
          .catch(function (error) {
            reject(error);
          });
      });
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
};
